import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";

const getWithdrawal = async (id: string) => {
  const response = await axios.get<WithdrawalWithUser>(`/withdrawals/${id}`);
  return response.data;
};

export const useWithdrawal = (id: string) => {
  const {
    data: withdrawal,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["withdrawal", id],
    queryFn: () => getWithdrawal(id),
    enabled: !!id,
  });

  return { withdrawal, loading, error };
};
